<script setup lang="ts">
import type { FormVariants } from '@/components/ui/form/index.js'
import { formVariants } from '@/components/ui/form/index.js'

const props = defineProps<{
	variant?: FormVariants['variant']
}>()
</script>

<template>
	<form v-auto-animate :class="cn(formVariants({ variant: props.variant }))">
		<slot />
	</form>
</template>
